import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';
import { makeQueryString } from '../../util';

export type V_DetailAsAdmin = {
  '@id': string;
  '@type': 'DailyTip';
  id: string;
  day: number;
  title: string;
  description: string;
  publishedAt: string | null;
};

export type V_ProgramWeekSub = {
  '@id': string;
  '@type': 'DailyTip';
  id: string;
  day: number;
  title: string;
  description: string;
  publishedAt: string | null;
};

export type W = {
  day: number;
  title: string;
  description: string;
  week: string;
};

export function useReadCollectionDailyTips(
  id: string,
  queryParams?: { 'order[day]'?: string; title?: string },
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V_ProgramWeekSub>>(
    `/program-weeks/${id}/daily-tips${makeQueryString(queryParams)}`,
    options,
  );
}

export function useReadItem(id: string, options?: ReadConfig) {
  return useApiRead<V_DetailAsAdmin>(`/daily-tips/${id}`, options);
}
